import React from 'react'
import PropTypes from 'prop-types'
import { GoogleLogin } from '@react-oauth/google'
import { View } from '@olxbr/design-system'
import styled from 'styled-components'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 56px;
  width: 40px;
  margin-right: 8px;
  margin-left: 8px;
  transform: scale(1.42);
`

class GoogleSignInSDK extends React.Component {
  onFailure = ({ error = 'unknown', details = 'unknown' }) => {
    const { onCancel, onError } = this.props
    const message = `${error}: ${details}`

    switch (error) {
      case 'popup_closed_by_user':
        if (typeof onCancel === 'function') {
          onCancel(message)
        }
        break

      case 'idpiframe_initialization_failed':
        if (typeof onError === 'function') {
          onError({ code: 'google_initialization_error', message: details || 'unknown' })
        }
        break

      default:
        if (typeof onError === 'function') {
          onError({ code: 'google_unexpected_error', message })
        }
    }
  }

  render() {
    const { onSuccess, onClick } = this.props

    return (
      <Content>
        <GoogleLogin
          onSuccess={credentialResponse => {
            onSuccess(credentialResponse.credential)
          }}
          onError={error => {
            onFailure(error)
          }}
          click_listener={onClick}
          type="icon"
          shape="circle"
        />
      </Content>
    )
  }
}

GoogleSignInSDK.propTypes = {
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  onClick: PropTypes.func,
  render: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
}

export default GoogleSignInSDK
